import React from 'react';
import { CommentPayload } from '../../services/comment.service';

import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import Markdown from "react-markdown";
import Card from '@mui/material/Card/Card';
import CardContent from '@mui/material/CardContent/CardContent';
import Stack from '@mui/material/Stack/Stack';
import Avatar from '@mui/material/Avatar/Avatar';
import Box from '@mui/material/Box/Box';
import Typography from '@mui/material/Typography/Typography';

dayjs.extend(relativeTime);
export const Comment = (comment: CommentPayload) => {
    const postTime = dayjs(comment.createdAt).fromNow();
    const updatedTime = dayjs(comment.updatedAt).fromNow();
    return (
        <Card>
            <CardContent>
                <Stack spacing={1.5} direction="row">
                    <Avatar sx={{ width: 32, height: 32, fontSize: '0.9rem' }}>{(comment.author.username || '?').charAt(0).toUpperCase()}</Avatar>
                    <Stack spacing={0.5} direction="column" sx={{ minWidth: 0, flex: 1 }}>
                        <Typography variant="body2" color="text.secondary">
                            <Box component="b" sx={{ color: 'text.primary' }}>{comment.author.username}</Box> · {postTime}{updatedTime !== postTime && ` · edited ${updatedTime}`}
                        </Typography>
                        <div className="marked"><Markdown>{comment.text}</Markdown></div>
                    </Stack>
                </Stack>
            </CardContent>
        </Card>
    )
}